import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import PageHeader from "../../Utility/PageHeader";
import { useDispatch, useSelector } from "react-redux";
import LoadingAnimation from "../../shared/LoadingAnimation";
import NoContentsFound from "../../shared/NoContentsFound";
import ControlWaitingTable from "./ControlWaitingTalbe";

import { PendingControls } from "../../redux/ControlSection/PendingControls";
// import DriverTabularView from "./DriverTabularView";
// import { sendSMS } from "./SendSMS";

export default function ControlListWaiting() {
  // sendSMS();
  const { t } = useTranslation("translation");
  const data = useSelector((state) => state.control.data);
  const loading = useSelector((state) => state.control.loading);

  const CarsData = useSelector((state) => state.control);
  // const progress = useSelector((state) => state.vehicle.progress);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.authentication.token);

  useEffect(() => {
    dispatch(PendingControls(token));
  }, []);
  return (
    <div>
      <div className="mt-2">
        {/* <FormHeader province={"Kabul"} /> */}
        <PageHeader title={t("dash_board_card.pendingControls")} />
      </div>
      {loading ? (
        <LoadingAnimation />
      ) : data && data.length > 0 ? (
        <ControlWaitingTable carsData={CarsData} recordType={t("vehicle_details_form.processingControlVehicleList")} />
      ) : (
        <NoContentsFound message={t("general_key_words.dataNotFound")} />
      )}
    </div>
  );
}
